// shame.js

/**
 * Fix structured data
 */
(function ($) {

  //NOOP

})(window.jQuery);
